import React from "react";
import { Outlet } from "react-router-dom";

import { NavigationDrawer } from "@src/components/Navigation/BaseSideNav/NavigationDrawer";

import { AppLayoutShell } from "./layout/AppLayoutShell";
import { AdminSideNav } from "@src/components/Navigation/AdminSideNav/AdminSideNav";
import { AlertBanner } from "@src/providers/alerts/AlertBanner";

export const AdminNoPaddingPageProvider = () => {
  return (
    <AppLayoutShell
      banner={<AlertBanner />}
      sideNav={<AdminSideNav />}
      maxWidth="none"
    >
      <Outlet />
    </AppLayoutShell>
  );
};
